import { render, staticRenderFns } from "./SpecificationList.vue?vue&type=template&id=1103e6ee&"
import script from "./SpecificationList.vue?vue&type=script&lang=js&"
export * from "./SpecificationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports